import { Nullable } from "chat/imports/types";

export const GROUP_CHAT_ID_PREFIX = "GROUP:";

export default function isGroupChatId(id: Nullable<string>): boolean {
  return typeof id === "string" && id.startsWith(GROUP_CHAT_ID_PREFIX);
}
